import './index.css';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

// Create Emotion cache with nonce
const cache = createCache({
  key: 'css',
  nonce: '11424717263069675', // Same nonce used in CSP
});

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <CacheProvider value={cache}>
      <App />
    </CacheProvider>
  </React.StrictMode>,
);
